<template>
  <div class="container">
    <div class="row">
      <div class="max-w-7xl mx-auto col-sm-12 flex flex-col gap-3 py-3">
        <h2 class="text-2xl font-bold">Pré-Inscrição</h2>
        <p class="text-sm font-medium -top-12">
          Preencha os campos com seus dados reais.
        </p>
        <div class="grid grid-cols-1">
          <div
            class="border border-gray-200 p-6 bg-white shadow-md rounded-md h-[20vh]"
          >
            <div class="flex justify-between items-center mb-6">
              <div
                v-for="(s, index) in steps"
                :key="s"
                class="flex flex-col items-center flex-1"
                :class="index < steps.length - 1 ? 'relative' : ''"
              >
                <div
                  v-if="index < steps.length - 1"
                  :class="index < step ? 'bg-green-500' : 'bg-gray-300'"
                  class="absolute top-6 left-1/2 w-full h-0.5"
                />

                <div
                  class="relative z-10 w-12 h-12 rounded-full flex items-center justify-center mb-2"
                  :class="
                    index <= step
                      ? 'bg-green-500 text-white'
                      : 'bg-gray-300 text-gray-600'
                  "
                >
                  <component :is="s.icon" class="w-5 h-5" />
                </div>

                <div class="text-center">
                  <h3
                    class="text-[10px] md:text-sm font-medium truncate"
                    :class="index <= step ? 'text-green-600' : 'text-gray-600'"
                  >
                    {{ s.title }}
                  </h3>
                  <p class="hidden lg:block text-xs text-gray-500 mt-1">
                    {{ s.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white shadow-md border border-gray-200 rounded-md">
          <div class="row">
            <div class="col-lg-12">
              <div class="card-body">
                <form action="#" method="post">
                  <!-- personal User data -->
                  <div v-show="step == 0">
                    <h1 class="text-center mb-5 font-bold">Dados Pessoais</h1>
                  </div>
                  <div class="row" v-show="step == 0">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Nome Completo
                          <span class="text-danger">:*</span></label
                        >
                        <input
                          @input="onUserTypefullName"
                          type="text"
                          class="form-control"
                          v-model="userData.fullName"
                        />
                      </div>
                      <p v-if="fullname_message_error" style="color: red">
                        {{ fullname_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Data de Nasci.<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <input
                          @input="onUserTypeBithDate"
                          type="date"
                          name="datepicker"
                          class="datepicker-default form-control"
                          id="datepicker1"
                          v-model="userData.birthDate"
                        />
                      </div>
                      <p v-if="birthDate_message_error" style="color: red">
                        {{ birthDate_message_error }}
                      </p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Gênero<span class="text-danger">:*</span></label
                        >
                        <select
                          @change="GenderChange"
                          class="form-control"
                          v-model="userData.gender"
                        >
                          <option value="Gender">Gênero</option>
                          <option value="Masculino">Masculino</option>
                          <option value="Feminino">Feminino</option>
                          <option value="Outro">Outro</option>
                        </select>
                      </div>
                      <p v-if="gender_message_error" style="color: red">
                        {{ gender_message_error }}
                      </p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Email<span class="text-danger">:*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="userData.email"
                          @input="validateEmail"
                        />
                      </div>
                      <p v-if="emailError" style="color: red">
                        {{ emailError }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Contacto<span class="text-danger">:*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          @keypress="numberOnly"
                          pattern="/^[0-9]+$/"
                          maxlength="9"
                          v-model="userData.contacts.contact"
                          @input="validatePhoneNumber"
                        />
                      </div>
                      <p v-if="phoneNumberError" style="color: red">
                        {{ phoneNumberError }}
                      </p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label">Contacto Alternativo</label>
                        <input
                          type="text"
                          class="form-control"
                          @keypress="numberOnly"
                          pattern="/^[0-9]+$/"
                          maxlength="9"
                          v-model="userData.contacts.alternative_contact"
                          @input="validatePhoneNumberAlternative"
                        />
                      </div>
                      <p v-if="phoneNumberErrorAlternative" style="color: red">
                        {{ phoneNumberErrorAlternative }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Tem alugma deficiência?<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <select
                          @change="is_deficientChange($event)"
                          class="form-control"
                          v-model="userData.is_deficient"
                        >
                          <option value="-1">Selecione</option>
                          <option value="0">Não</option>
                          <option value="1">Sim</option>
                        </select>
                      </div>
                      <p v-if="isDeficient_message_error" style="color: red">
                        {{ isDeficient_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Selecione o tipo de deficiência</label
                        >
                        <select
                          class="form-control"
                          :disabled="deficientTypeDisabled"
                          v-model="userData.deficient_type"
                        >
                          <option value="" selected>Selecione o tipo</option>
                          <option value="Deficiencia Visual">
                            Deficiência Visual
                          </option>
                          <option value="Cegueira">Cegueira</option>
                          <option value="Paraplegia">Paraplegia</option>
                          <option value="Paraparesia">Paraparesia</option>
                          <option value="Monoplegia">Monoplegia</option>
                          <option value="Baixa Visao">Baixa visao</option>
                          <option value="HipoMiopia">HipoMiopia</option>
                          <option value="HiperMiopia">HiperMiopia</option>
                          <option value="Surdez Condutiva">
                            Surdez Condutiva
                          </option>
                          <option value="Surdez Sensorioneural">
                            Surdez Sensorioneural
                          </option>
                          <option value="Surdez Mista">Surdez Mista</option>
                          <option value="Surdez Central">Surdez Central</option>
                          <option value="Outra">Outra</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Nome do Pai<span class="text-danger">:*</span></label
                        >
                        <input
                          @input="onUserTypeFatherName"
                          type="text"
                          class="form-control"
                          v-model="userData.fathers_filliation"
                        />
                      </div>
                      <p v-if="father_name_message_error" style="color: red">
                        {{ father_name_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Nome da Mãe<span class="text-danger">:*</span></label
                        >
                        <input
                          @input="onUserTypeMotherName"
                          type="text"
                          class="form-control"
                          v-model="userData.mothers_filliation"
                        />
                      </div>
                      <p v-if="mother_name_message_error" style="color: red">
                        {{ mother_name_message_error }}
                      </p>
                    </div>
                  </div>

                  <!-- End -->

                  <div v-show="step == 1">
                    <h1 class="text-center mb-5 font-bold">Documentação</h1>
                  </div>
                  <div class="row" v-show="step == 1">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Selecione o tipo documento<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <select
                          @change="ChangeDocType"
                          class="form-control"
                          v-model="userData.doc_type"
                        >
                          <option value="Class">
                            Selecione o tipo documento
                          </option>
                          <option value="Bilhete de Identidade">
                            Bilhete de Identidade
                          </option>
                        </select>
                      </div>
                      <p v-if="doc_message_error" style="color: red">
                        {{ doc_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Número do doc<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="userData.doc_number"
                          maxlength="13"
                          @input="validateIdentificationNumber"
                        />
                      </div>
                      <p v-if="doc_number_message_error" style="color: red">
                        {{ doc_number_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-4">
                      <div class="form-group">
                        <label for="">País:*</label>
                        <select
                          @change="ChangeCountry"
                          v-model="userData.nactionality"
                          class="form-control"
                        >
                          <option value="Afeganistão">Afeganistão</option>
                          <option value="Albânia">Albânia</option>
                          <option value="Alemanha">Alemanha</option>
                          <option value="Andorra">Andorra</option>
                          <option value="Angola">Angola</option>
                          <option value="Arábia Saudita">Arábia Saudita</option>
                          <option value="Argélia">Argélia</option>
                          <option value="Argentina">Argentina</option>
                          <option value="Austrália">Austrália</option>
                          <option value="Áustria">Áustria</option>
                          <option value="Bangladesh">Bangladesh</option>
                          <option value="Bélgica">Bélgica</option>
                          <option value="Bolívia">Bolívia</option>
                          <option value="Brasil">Brasil</option>
                          <option value="Burundi">Burundi</option>
                          <option value="Botsuana">Botsuana</option>
                          <option value="Canadá">Canadá</option>
                          <option value="Cabo Verde">Cabo Verde</option>
                          <option value="Chile">Chile</option>
                          <option value="China">China</option>
                          <option value="Colômbia">Colômbia</option>
                          <option value="Comores">Comores</option>
                          <option value="Coreia do Sul">Coreia do Sul</option>
                          <option value="Costa Rica">Costa Rica</option>
                          <option value="Eswatini">Eswatini</option>
                          <option value="Dinamarca">Dinamarca</option>
                          <option value="Egito">Egito</option>
                          <option value="Emirados Árabes Unidos">
                            Emirados Árabes Unidos
                          </option>
                          <option value="Equador">Equador</option>
                          <option value="Espanha">Espanha</option>
                          <option value="Estados Unidos">Estados Unidos</option>
                          <option value="Estônia">Estônia</option>
                          <option value="Finlândia">Finlândia</option>
                          <option value="França">França</option>
                          <option value="Grécia">Grécia</option>
                          <option value="Holanda">Holanda</option>
                          <option value="Índia">Índia</option>
                          <option value="Indonésia">Indonésia</option>
                          <option value="Inglaterra">Inglaterra</option>
                          <option value="Irlanda">Irlanda</option>
                          <option value="Itália">Itália</option>
                          <option value="Japão">Japão</option>
                          <option value="Luxemburgo">Luxemburgo</option>
                          <option value="Malawi">Malawi</option>
                          <option value="Madagáscar">Madagáscar</option>
                          <option value="México">México</option>
                          <option value="Moçambique" selected>
                            Moçambique
                          </option>
                          <option value="Namíbia">Namíbia</option>
                          <option value="Noruega">Noruega</option>
                          <option value="Nova Zelândia">Nova Zelândia</option>
                          <option value="Panamá">Panamá</option>
                          <option value="Paraguai">Paraguai</option>
                          <option value="Peru">Peru</option>
                          <option value="Polônia">Polônia</option>
                          <option value="Portugal">Portugal</option>
                          <option value="Reino Unido">Reino Unido</option>
                          <option value="República Tcheca">
                            República Tcheca
                          </option>
                          <option value="Romênia">Romênia</option>
                          <option value="Ruanda">Ruanda</option>
                          <option value="Rússia">Rússia</option>
                          <option value="Suécia">Suécia</option>
                          <option value="Suíça">Suíça</option>
                          <option value="Tanzânia">Tanzânia</option>
                          <option value="Turquia">Turquia</option>
                          <option value="Ucrânia">Ucrânia</option>
                          <option value="Uganda">Uganda</option>
                          <option value="Uruguai">Uruguai</option>
                          <option value="Venezuela">Venezuela</option>
                          <option value="Vietnã">Vietnã</option>
                          <option value="Zâmbia">Zâmbia</option>
                          <option value="Zimbábue">Zimbábue</option>
                        </select>
                      </div>
                      <p v-if="country_message_error" style="color: red">
                        {{ country_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Selecione o Província<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <select
                          class="form-control"
                          v-model="userData.provice_id"
                          @change="ChangeProvince($event)"
                        >
                          <option value="0">Selecione o Província</option>
                          <option
                            :value="provinces.id"
                            v-for="provinces in provincesData"
                            :key="provinces.id"
                          >
                            {{ provinces.name }}
                          </option>
                        </select>
                      </div>
                      <p v-if="province_message_error" style="color: red">
                        {{ province_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Selecione o Distrito<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <select
                          @change="ChangeDistrict"
                          :disabled="loadDistricts"
                          class="form-control"
                          v-model="userData.district_id"
                        >
                          <option value="0">Selecione o Distrito</option>
                          <option
                            :value="district.id"
                            v-for="district in districtData"
                            :key="district.id"
                          >
                            {{ district.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label for=""
                          >Bairro/AVENIDA<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="userData.address_location"
                          @input="onUserTypeAddressLocation"
                        />
                      </div>
                      <p v-if="address_message_error" style="color: red">
                        {{ address_message_error }}
                      </p>
                    </div>
                  </div>

                  <div v-show="step == 2">
                    <h1 class="text-center mb-5 font-bold">Nível Acadêmico</h1>
                  </div>
                  <div class="row" v-show="step == 2">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >última escola que frequentou<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <input
                          @input="onUserTypeLastSchoolFrequency"
                          type="text"
                          class="form-control"
                          v-model="userData.last_school_frequency"
                        />
                      </div>
                      <p v-if="last_school_message_error" style="color: red">
                        {{ last_school_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Formação<span class="text-danger">:*</span></label
                        >
                        <select
                          @change="ChangeTraining"
                          class="form-control"
                          v-model="userData.trainingArea"
                        >
                          <option value="Geral">Geral</option>
                          <option value="Tecnico">Técnico</option>
                        </select>
                      </div>
                      <p v-if="trainingArea_message_error" style="color: red">
                        {{ trainingArea_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Ano de conclusão<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <select
                          @change="changeYearLastSchool"
                          class="form-control"
                          v-model="userData.last_school_frequency_year"
                        >
                          <option value="Gender">Ano de Frequência</option>
                          <option
                            :value="y"
                            v-for="(y, index) in listYear"
                            :key="index"
                          >
                            {{ y }}
                          </option>
                        </select>
                      </div>
                      <p
                        v-if="last_school_year_message_error"
                        style="color: red"
                      >
                        {{ last_school_year_message_error }}
                      </p>
                    </div>
                  </div>

                  <div v-show="step == 3">
                    <h1 class="text-center mb-5 font-bold">Curso</h1>
                  </div>
                  <div class="row" v-show="step == 3">
                    <div class="col-lg-4 col-md-12 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Selecione o Curso<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <select
                          @change="ChangeCourse"
                          class="form-control"
                          v-model="userData.course_id"
                        >
                          <option value="Class">Selecione o Curso</option>
                          <option
                            :value="courses.id"
                            v-for="courses in DataCourse"
                            :key="courses.id"
                          >
                            {{ courses.name }}
                          </option>
                        </select>
                      </div>
                      <p v-if="course_message_error" style="color: red">
                        {{ course_message_error }}
                      </p>
                    </div>

                    <div class="col-lg-6 col-md-12 col-sm-12">
                      <div class="form-group">
                        <label class="form-label"
                          >Selecione o Regime<span class="text-danger"
                            >:*</span
                          ></label
                        >
                        <select
                          @change="ChangeScholarShift"
                          class="form-control"
                          v-model="userData.scholar_shift"
                        >
                          <option value="Class">Regime</option>
                          <option value="LABORAL">LABORAL</option>
                          <option value="POS-LABORAL">POS-LABORAL</option>
                        </select>
                      </div>
                      <p v-if="scholar_shift_message_error" style="color: red">
                        {{ scholar_shift_message_error }}
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <button
                      v-if="step === steps.length - 1"
                      type="button"
                      v-on:click="handleSubmitButton"
                      class="btn btn-primary float-right"
                    >
                      {{ loading == false ? "Submeter" : "Aguarde..." }}
                    </button>

                    <button
                      v-else
                      type="button"
                      class="btn btn-primary float-right"
                      v-on:click="handleNextStep"
                    >
                      Próximo
                    </button>

                    <button
                      v-if="step > 0"
                      type="button"
                      class="btn btn-light"
                      v-on:click="handleBackSchool"
                    >
                      Voltar
                    </button>
                    <!-- <div /> -->
                  </div>
                </form>
                <div class="new-account mt-3 text-center">
                  <p>
                    Já tem uma conta?
                    <router-link style="color: #0093dd" to="/"
                      >Clique aqui</router-link
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Loading :loadingData="loading"></Loading>
</template>

<script>
import axios from "axios";
import toastr from "toastr";
import StudentModuleService from "../students/StudentModuleService";
import Loading from "../../components/Loading.vue";
import Swal from "sweetalert2";
import {
  Book,
  FileText,
  GraduationCap,
  MapPin,
  UserCheck,
} from "lucide-vue-next";
const URL_API = process.env.VUE_APP_URL_API;

export default {
  components: {
    Loading,
  },
  data() {
    return {
      steps: [
        {
          title: "Dados Pessoais",
          icon: UserCheck,
          description: "Informações básicas de contacto",
        },
        {
          title: "Documentos",
          icon: FileText,
          description: "Tipo e número do documento",
        },
        {
          title: "Nível académico",
          icon: Book,
          description: "Ultima formação",
        },
        // {
        //   title: "Endereço",
        //   icon: MapPin,
        //   description: "Informe dados do endereço",
        // },
        {
          title: "Curso",
          icon: GraduationCap,
          description: "Escolhe o curso que deseja frequentar",
        },
      ],
      listYear: [],
      step: 0,
      firstInfoShow: true,
      secondInfoShow: false,
      stepThreeInfo: false,
      stepFourInfo: false,
      personalData: true,
      loadDistricts: true,
      schoolData: false,
      courseData: false,
      documentData: false,
      loading: false,
      deficientTypeDisabled: true,
      userData: {
        fullName: "",
        address_location: "",
        email: "",
        gender: "",
        doc_type: "",
        doc_number: "",
        nactionality: "Moçambique",
        birthDate: "",
        last_school_frequency: "",
        level_type: "",
        last_school_frequency_year: "",
        fathers_filliation: "",
        mothers_filliation: "",
        childhood_location: "",
        is_deficient: "",
        deficient_type: "",
        course_id: "",
        contacts: {
          contact: "",
          alternative_contact: "",
        },
        provice_id: "",
        district_id: "",
        regime: "",
        regimeSuperior: "",
        scholar_shift: "",
        level_id: "0",
        trainingArea: "",
      },
      levels: [],
      provincesData: [],
      districtData: [],
      DataCourse: [],

      // Validate variable
      emailError: "",
      phoneNumberError: "",
      phoneNumberErrorAlternative: "",
      birthDate_message_error: "",
      district_message_error: "",
      address_message_error: "",
      doc_message_error: "",
      gender_message_error: "",
      isDeficient_message_error: "",
      father_name_message_error: "",
      mother_name_message_error: "",
      country_message_error: "",
      province_message_error: "",
      fullname_message_error: "",
      nationality_message_error: "",
      number_message_error: "",
      doc_number_message_error: "",
      last_school_message_error: "",
      last_school_year_message_error: "",
      regime_message_error: "",
      course_message_error: "",
      level_message_error: "",
      scholar_shift_message_error: "",
      trainingArea_message_error: "",
    };
  },
  methods: {
    getYear() {
      let today = new Date();
      const startYear = 1999;
      let currentYear = today.getFullYear();

      for (let year = currentYear; year >= startYear; year--) {
        this.listYear.push(year);
      }
    },
    ChangeDocType() {
      this.onUserTypeDocument();
    },
    ChangeScholarShift() {
      this.onUserTypeScholarShift();
    },
    ChangeLevel() {
      this.onUserTypeLevel();
    },

    ChangeCourse() {
      this.onUserTypeCourse();
    },
    changeYearLastSchool() {
      this.onUserTypeLastSchoolYear();
    },
    ChangeTraining() {
      this.onUserTypeTrainingArea();
    },
    ChangeDistrict() {
      this.onUserTypeDistrict();
    },

    ChangeCountry() {
      this.onUserTypeCountry();
    },
    GenderChange(evt) {
      this.onUserTypeGender();
    },
    // Validacao no numero BI
    validateIdentificationNumber() {
      const regex = /^[0-9]{12}[a-zA-Z]$/;

      // Testar a expressão regular
      if (!regex.test(this.userData.doc_number)) {
        this.doc_number_message_error = "Número de identificação inválido!";

        return;
      } else {
        this.doc_number_message_error = "";
      }
    },

    validatePhoneNumber() {
      const validPrefixes = ["82", "83", "84", "85", "86", "87"];
      const number = this.userData.contacts.contact;

      // Verifica se é um número de 9 dígitos numéricos
      const isNumeric = /^\d{9}$/.test(number);

      if (!isNumeric) {
        this.phoneNumberError =
          "O número deve ter exatamente 9 dígitos numéricos.";
        return;
      }

      const prefix = number.slice(0, 2);

      if (!validPrefixes.includes(prefix)) {
        this.phoneNumberError =
          "Por favor, insira um número de telefone válido para Moçambique.";
      } else {
        this.phoneNumberError = ""; // número válido
      }
    },

    validatePhoneNumberAlternative() {
      const validPrefixes = ["82", "83", "84", "85", "86", "87"];
      const number = this.userData.contacts.alternative_contact;

      // Verifica se é um número de 9 dígitos numéricos
      const isNumeric = /^\d{9}$/.test(number);

      if (!isNumeric) {
        this.phoneNumberErrorAlternative =
          "O número deve ter exatamente 9 dígitos numéricos.";
        return;
      }

      const prefix = number.slice(0, 2);

      if (!validPrefixes.includes(prefix)) {
        this.phoneNumberErrorAlternative =
          "Por favor, insira um número de telefone válido para Moçambique.";
      } else {
        this.phoneNumberErrorAlternative = ""; // número válido
      }
    },
    // validate inputs
    onUserTypefullName() {
      if (this.userData.fullName != "") {
        this.fullname_message_error = "";
      }
    },

    onUserTypeFatherName() {
      if (this.userData.fathers_filliation !== "") {
        this.father_name_message_error = "";
      }
    },

    onUserTypeMotherName() {
      if (this.userData.mothers_filliation !== "") {
        this.mother_name_message_error = "";
      }
    },

    onUserTypeGender() {
      if (this.userData.gender !== "") {
        this.gender_message_error = "";
      }
    },

    onUserTypeIsdeficient() {
      if (this.userData.is_deficient !== "") {
        this.isDeficient_message_error = "";
      }
    },

    onUserTypeLastSchoolFrequency() {
      if (this.userData.last_school_frequency !== "") {
        this.last_school_message_error = "";
      }
    },
    onUserTypeCourse() {
      if (this.userData.course_id !== "") {
        this.course_message_error = "";
      }
    },

    onUserTypeTrainingArea() {
      if (this.userData.trainingArea !== "") {
        this.trainingArea_message_error = "";
      }
    },

    onUserTypeLastSchoolYear() {
      if (this.userData.last_school_frequency_year !== "") {
        this.last_school_year_message_error = "";
      }
    },

    onUserTypeCountry() {
      if (this.userData.nactionality !== "") {
        this.country_message_error = "";
      }
    },

    onUserTypeProvince() {
      if (this.userData.provice_id !== "") {
        this.province_message_error = "";
      }
    },

    onUserTypeDistrict() {
      if (this.userData.district_id !== "") {
        this.district_message_error = "";
      }
    },

    onUserTypeAddressLocation() {
      if (this.userData.address_location !== "") {
        this.address_message_error = "";
      }
    },

    onUserTypeDocument() {
      if (this.userData.doc_type !== "") {
        this.doc_message_error = "";
      }
    },
    onUserTypeLevel() {
      if (this.userData.level_id !== "") {
        this.level_message_error = "";
      }
    },
    onUserTypeScholarShift() {
      if (this.userData.scholar_shift !== "") {
        this.scholar_shift_message_error = "";
      }
    },

    validateEmail() {
      // Expressão regular para validar o formato de um e-mail
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Verifica se o e-mail atende ao formato esperado
      if (!emailRegex.test(this.userData.email)) {
        this.emailError = "Por favor, insira um endereço de e-mail válido.";
      } else {
        this.emailError = null;
      }
    },

    async getLevels() {
      const resp = await StudentModuleService.actions.getLevelsCandi();
      this.levels = resp.data;
    },
    clearInputs() {
      this.userData.address_location = "";
      this.userData.contacts.alternative_contact = "";
      this.userData.birthDate = "";
      this.userData.childhood_location = "";
      this.userData.contacts.contact = "";
      this.userData.course_id = "";
      this.userData.deficient_type = "";
      this.userData.district_id = "";
      this.userData.doc_number = "";
      this.userData.doc_type = "";
      this.userData.email = "";
      this.userData.fathers_filliation = "";
      (this.userData.nactionality = "Moçambique"), (this.userData.gender = "");
      this.userData.is_deficient = "";
      this.userData.last_school_frequency = "";
      this.userData.last_school_frequency_year = "";
      this.userData.level_type = "";
      this.userData.mothers_filliation = "";
      this.userData.fullName = "";
      this.userData.provice_id = "";
      this.userData.regime = "";
      this.userData.regimeSuperior = "";
      this.userData.trainingArea = "";
    },
    handleNextStep() {
      if (this.step == 0) {
        if (this.userData.fullName == "") {
          this.fullname_message_error =
            "O campo nome completo não pode estar vazio!";
          return;
        }

        if (this.userData.birthDate == "") {
          this.birthDate_message_error =
            "O campo data de Nascimento não pode estar vazio!";
          return;
        }

        if (this.userData.gender == "") {
          this.gender_message_error = "O campo genero não pode estar vazio!";
          return;
        }

        if (this.userData.email == "") {
          this.emailError = "O campo email não pode estar vazio!";
          return;
        }

        if (this.userData.contacts.contact == "") {
          this.phoneNumberError = "O campo contacto não pode estar vazio!";
          return;
        }

        if (this.phoneNumberError != "") {
          this.phoneNumberError =
            "Por favor, insira um número de telefone válido para Moçambique.";
          return;
        }

        if (this.phoneNumberErrorAlternative != "") {
          this.phoneNumberErrorAlternative =
            "Por favor, insira um número de telefone válido para Moçambique.";

          return;
        }

        if (this.userData.is_deficient == "") {
          return (this.isDeficient_message_error =
            "O campo deficiência não pode estar vazio!");
        }

        if (this.userData.fathers_filliation == "") {
          this.father_name_message_error =
            "O campo nome do pai não pode estar vazio!";
          return;
        }

        if (this.userData.mothers_filliation == "") {
          this.mother_name_message_error =
            "O campo nome da mãe não pode estar vazio!";
          return;
        }
        if (this.birthDate_message_error === "Menor de idade") {
          this.birthDate_message_error = "Informe uma data válida!";
          return;
        }
      }

      if (this.step == 1) {
        if (
          this.userData.doc_type == "" ||
          this.userData.doc_type !== "Bilhete de Identidade"
        ) {
          this.doc_message_error =
            "O campo tipo de documento não pode estar vazio!";
          return;
        }

        if (this.userData.doc_number == "") {
          this.doc_number_message_error =
            "O campo numero do documento não pode estar vazio!";
          return;
        }

        if (this.userData.nactionality == "") {
          this.country_message_error =
            "O campo nacionalidade não pode estar vazio!";
          return;
        }

        if (this.userData.provice_id == "") {
          this.province_message_error =
            "O campo província não pode estar vazio!";
          return;
        }

        if (this.userData.district_id == "") {
          this.district_message_error =
            "O campo districto não pode estar vazio!";
          return;
        }

        if (this.userData.address_location == "") {
          this.address_message_error =
            "O campo bairro ou avenida não estar vazio!";
          return;
        }
      }

      if (this.step == 2) {
        if (this.userData.last_school_frequency == "") {
          this.last_school_message_error =
            "O campo ultima escola não pode estar vazio!";
          return;
        }

        if (this.userData.trainingArea == "") {
          this.trainingArea_message_error =
            "O campo formacao não pode estar vazio!";
          return;
        }

        if (this.userData.last_school_frequency_year == "") {
          this.last_school_year_message_error =
            "O campo nacionalidade não pode estar vazio!";
          return;
        }
      }
      this.step++;
    },

    handleStepTwo() {
      if (
        this.userData.doc_type == "" ||
        this.userData.doc_type !== "Bilhete de Identidade"
      ) {
        this.doc_message_error =
          "O campo tipo de documento não pode estar vazio!";
        return;
      }

      if (this.userData.doc_number == "") {
        this.doc_number_message_error =
          "O campo numero do documento não pode estar vazio!";
        return;
      }

      if (this.userData.nactionality == "") {
        this.country_message_error =
          "O campo nacionalidade não pode estar vazio!";
        return;
      }

      if (this.userData.provice_id == "") {
        this.province_message_error = "O campo província não pode estar vazio!";
        return;
      }

      if (this.userData.district_id == "") {
        this.district_message_error = "O campo districto não pode estar vazio!";
        return;
      }

      if (this.userData.address_location == "") {
        this.address_message_error =
          "O campo bairro ou avenida não estar vazio!";
        return;
      }

      this.secondInfoShow = false;
      this.stepThreeInfo = true;
      this.documentData = false;
      this.schoolData = true;
    },

    onUserTypeBithDate() {
      let currentYear = new Date().getFullYear();
      let year = new Date(this.userData.birthDate).getFullYear();

      if (this.userData.birthDate !== "") {
        if (currentYear - year < 18) {
          this.birthDate_message_error = "Menor de idade";
        } else {
          this.birthDate_message_error = "";
        }
      }
    },
    handleStepThree() {
      if (this.userData.last_school_frequency == "") {
        this.last_school_message_error =
          "O campo ultima escola não pode estar vazio!";
        return;
      }

      if (this.userData.trainingArea == "") {
        this.trainingArea_message_error =
          "O campo formacao não pode estar vazio!";
        return;
      }

      if (this.userData.last_school_frequency_year == "") {
        this.last_school_year_message_error =
          "O campo nacionalidade não pode estar vazio!";
        return;
      }

      this.stepThreeInfo = false;
      this.stepFourInfo = true;
      this.schoolData = false;
      this.couseData = true;
    },

    // handleStepFour() {
    //   if (this.userData.course == "" || this.userData.regimeSuperior == "") {
    //     return bridge.warning(
    //       "Por favor preecha os campos obrigatorios",
    //       "Opsssiiii"
    //     );
    //   }
    // },

    handleBackInfo() {
      this.secondInfoShow = false;
      this.firstInfoShow = true;
      this.documentData = false;
      this.personalData = true;
    },

    handleBackDocument() {
      this.firstInfoShow = false;
      this.schoolData = false;
      this.documentData = true;
      this.secondInfoShow = true;
      this.stepThreeInfo = false;
    },

    handleBackSchool() {
      this.step--;
      // Math.max(this)
    },

    goToFirstForm() {
      this.firstInfoShow = true;
      this.secondInfoShow = false;
      this.stepThreeInfo = false;
      this.stepFourInfo = false;
      this.personalData = true;
    },

    is_deficientChange(evt) {
      this.onUserTypeIsdeficient();
      if (evt.target.value < 0 || evt.target.value == 0) {
        this.deficientTypeDisabled = true;
      } else {
        this.deficientTypeDisabled = false;
      }
    },

    // Create new Candidate student
    async handleSubmitButton() {
      try {
        this.loading = true;

        if (this.userData.course_id == "") {
          this.course_message_error = "O campo curso não pode estar vazio!";
          this.loading = false;
          return;
        }
        // if (this.userData.level_id == "") {
        //   this.level_message_error = "O campo nivel nao pode estar vazio!";
        //   this.loading = false;
        //   return;
        // }
        if (this.userData.scholar_shift == "") {
          this.scholar_shift_message_error =
            "O campo regime não pode estar vazio!";
          this.loading = false;
          return;
        }

        if (this.birthDate_message_error === "Menor de idade") {
          this.birthDate_message_error = "Informe uma data válida!";
          return;
        }
        this.couseData = true;
        const response = await axios.post(URL_API + "Candidate", this.userData);
        console.log(response.data);
        if (response.data.status == true) {
          Swal.fire({
            title: "A sua candidatura foi submetida sucesso!",
            text: "Por favor verifique a sua caixa de email.",
            icon: "success",
          });
          this.clearInputs();
          this.goToFirstForm();
        }
      } catch (error) {
        console.log(error.response);
        if (typeof error.response != "undefined") {
          Object.keys(error.response.data.errors).forEach((key) => {
            toastr.info(key, error.response.data.errors[key]);
          });
        }
      } finally {
        this.loading = false;
      }
    },

    async getProvinces() {
      await axios
        .get(URL_API + "provinces")
        .then((response) => {
          // console.log(response);

          this.provincesData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async ChangeProvince(evt) {
      this.loadDistricts = true;
      this.onUserTypeProvince();
      await axios
        .get(URL_API + "district/" + evt.target.value)
        .then((response) => {
          // console.log(response);
          this.districtData = response.data;
          this.loadDistricts = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getAllCourses() {
      await axios
        .get(URL_API + "getAllCourses")
        .then((response) => {
          // console.log(response);
          this.DataCourse = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    numberOnly($event) {
      let keycode = $event.keyCode ? $event.keyCode : $event.which;

      if ((keycode < 48 || keycode > 57) && keycode !== 46) {
        $event.preventDefault();
      }
    },
  },

  created() {
    this.getProvinces();
    this.getAllCourses();
    this.getLevels();
    this.getYear();
  },
};
</script>
 